<template>
  <div class="help">
    <div class="help-wrapper" >
      <div class="help-content">
        <div class="help-block" v-for="(item,index) in nav" :key="index">
          <div class="title_level_1">{{ item.first_title }}</div>
          <div
            v-for="(sub,i) in item.user_second_list"
            :key="i"
            class="level_1_content">
            <div class="title_level_2" :data-id="`${index}-${i}`">
              {{ sub.second_name }}
            </div>
            <div class="level_2_content" v-if="sub.notes" v-html="sub.notes">
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="help-nav-wrapper">
      <div class="help-nav" @mouseover="flag = true" @mouseleave="flag = false">
        <a-timeline class="timeline" >
          <span class="active-nav"></span>
          <a-timeline-item color="#EEEEEE" v-for="(item,index) in nav" :key="index" >
            <p class="nav_title_1">{{ item.first_title }}</p>
            <p
              :data-navid="`${index}-${i}`"
              class="nav_title_2"
              v-for="(sub,i) in item.user_second_list"
              :key="i"
              @click="navClick(`${index}-${i}`)"
              :class="{active: activeNav == `${index}-${i}`}">{{ sub.second_name }}</p>
          </a-timeline-item>

          <a-timeline-item color="#ffffff" style="padding:0; height:0;">

          </a-timeline-item>
        </a-timeline>
        <div class="nav-list">
          <div class="nav-item"></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Bottom from '@/components/Layout/Bottom'
import { _throttle } from '@/utils/util'
export default {
  components: { Bottom },
  data () {
    return {
      activeNav: '0-0',
      flag: false,
      nav: []
    }
  },
  mounted () {
    document.addEventListener('scroll', _throttle(this.pageScroll, 200), false)
    this.getHelpInfo()
  },
  destroyed () {

  },
  methods: {
    getHelpInfo () {
      this.$api.user.get_help_info().then(
        res => {
          if (res.status === 'ok') {
            this.nav = res.data.help_list
          }
        }
      )
    },
    navScroll (e) {
      console.log(e)
    },
    pageScroll (e) {
      const subList = document.querySelectorAll('.title_level_2')
      const cHeight = document.documentElement.clientHeight
      if (!this.flag) {
        Array.from(subList).forEach((item) => {
          if (item.getBoundingClientRect().top - 88 < Math.floor(cHeight / 3) && item.getBoundingClientRect().top > 0) {
            this.activeNav = item.dataset.id
          }
        })
      }
    },
    getElementTop (el, para) {
      var top = el.offsetTop
      var current = el.offsetParent

      while (current !== null) {
        top += current.offsetTop
        current = current.offsetParent
      }
      return top
    },
    navClick (id) {
      const item = document.querySelector(`[data-id="${id}"]`)
      const top = id.split('-')[1] === '0' ? item.offsetTop - 64 : item.offsetTop
      window.scrollTo({
        top: top,
        behavior: 'smooth'
      })
      this.activeNav = id
    }
  }
}
</script>

<style lang="less" scoped>
.help {
  display: flex;
  position: relative;
  .help-wrapper{
    margin-right: 16px;
    flex: 1;
    .help-content {
      background-color: #ffffff;
      padding: 40px 38px 40px 32px;
      margin-bottom: 6px;
      .help-block {
        margin-bottom: 60px;
      }
      /deep/
      p {
        line-height: 24px;

      }
      /deep/
      img {
        max-width: 800px !important;
        height: auto;
      }

      /deep/
        table {
          border-top: 1px solid #ccc;
          border-left: 1px solid #ccc;
          td, th {
              border-bottom: 1px solid #ccc;
              border-right: 1px solid #ccc;
              padding: 3px 5px;
          }
          th {
            border-bottom: 2px solid #ccc;
            border-right: 1px solid #ccc;
            // text-align: center;
          }
        }
    }
  }

  .help-nav-wrapper {
    width: 336px;

  }
  .help-nav {
    position: fixed;
    right: 24px;
    top: 88px;
    width: 336px;
    z-index: 999;
    max-height: 568px;
    box-sizing: border-box;

    padding: 16px 0 16px 24px;
    background-color: #ffffff;
    .timeline {
       max-height: 536px;
      overflow: auto;
      padding: 14px 0;
      margin-right: 8px;
      box-sizing: border-box;
      .active-nav{
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    /deep/
    .ant-timeline{
      line-height: 1;
    }
    .ant-timeline-item {
      padding:  0 0 10px;
    }
    /deep/
    .ant-timeline-item-tail {
      border-color: #EEEEEE;
    }
    /deep/
    .ant-timeline-item-content {
      margin-left: 24px;
    }
    .nav_title_1 {
      color: #333333;
      font-size: 16px;
      margin-bottom: 30px;
      line-height: 1;
    }
    .nav_title_2 {
      color: #999999;
      font-size: 14px;
      cursor: pointer;
      line-height: 1;
      margin-bottom: 30px;
      &.active {
        position: relative;
        color: @primary-color;
        &::after {
          display: block;
          content:'';
          width: 14px;
          height: 14px;
          background-image: url('../../assets/img/img_selected_icon.png');
          background-size: 100% 100%;
          position: absolute;
          top: 0px;
          left: -24px;
        }
      }
      &:hover {
        color: @primary-color;
      }
    }
  }
  .img {
    width: inherit;
    margin-bottom: 25px;
    img{
      width: inherit;
      max-width: 100%;
    }
  }
  img {
    display: inline-block;
    width: 100%;
    height: auto;
  }
  .title_level_1 {
    color: @primary-color;
    font-size: 20px;
    font-weight: 400;
    line-height: 1;
    margin-bottom: 40px;
  }
  .level_1_content {
      margin-bottom: 40px;
       .title_level_2 {
          color: #333333;
          font-size: 16px;
          font-weight: 400;
          margin-bottom: 30px;
          line-height: 1;

        }
        .level_2_content {
          color: #666666;
          font-size: 16px;
          line-height: 24px;
          margin-bottom: 40px ;
        }
    }

}
</style>
